import { useCallback } from "react";

export default function ExamStep({ session, current }) {
    const getActiveTab = useCallback(() => {
        if (!session.data || session.data.length === 0) return null;

        let tabs = [];
        session.data.forEach((item) => {
            // Strip "- Kolom X" or "- Lembar X" suffix to group sessions under one tab
            let displayName = item.name;
            const kolomMatch = displayName.match(/^(.+?)\s*-\s*(?:Kolom|Lembar)\s+\d+$/);
            if (kolomMatch) {
                displayName = kolomMatch[1];
            }

            // Deduplicate
            if (tabs.indexOf(displayName) === -1) {
                tabs.push(displayName);
            }
        });

        return tabs.filter((item) => item !== undefined);
    }, [session.data]);

    // Get the display name for current session (strip Kolom suffix)
    const getCurrentTabName = () => {
        if (!session.data || current.data.session === null) return null;
        const currentName = session.data[current.data.session]?.name;
        if (!currentName) return null;
        const kolomMatch = currentName.match(/^(.+?)\s*-\s*(?:Kolom|Lembar)\s+\d+$/);
        return kolomMatch ? kolomMatch[1] : currentName;
    };

    const currentTabName = getCurrentTabName();

    return (
        <div className="px-0" style={{ flex: 2 }}>
            <div className="card" style={{ height: "100%" }}>
                <div className="card-body">
                    <h5 className="card-title border-bottom pb-3">Tahapan Ujian</h5>
                    <ul className="d-flex mt-3 px-0 justify-content-center flex-wrap" style={{ listStyle: "none" }}>
                        {getActiveTab() && getActiveTab().map((item, index) => (
                            <li key={index} className={`mx-1 my-1 py-1 px-3 border rounded-2 ${currentTabName === item ? 'bg-primary text-white border-primary' : ''}`}>
                                <span style={{ fontSize: '.8rem' }}>{item}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}
